import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/arrow-drop.svg'


const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = { class: "form-step" }
const _hoisted_4 = { class: "container-top-form" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "error-message"
}
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = {
  key: 0,
  class: "Contaider-options"
}
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "error-message"
}
const _hoisted_25 = { class: "input-group" }
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "error-message"
}
const _hoisted_28 = { class: "input-group" }
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 0,
  class: "error-message"
}
const _hoisted_31 = { class: "input-group" }
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "error-message"
}
const _hoisted_34 = { class: "container-top-form" }
const _hoisted_35 = { class: "input-group" }
const _hoisted_36 = { class: "container-conectividade" }
const _hoisted_37 = { class: "status-text" }
const _hoisted_38 = {
  class: "input-group",
  style: {"width":"100%"}
}
const _hoisted_39 = ["value"]
const _hoisted_40 = {
  key: 0,
  class: "error-message"
}
const _hoisted_41 = { class: "input-group" }
const _hoisted_42 = { class: "relative" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { key: 3 }
const _hoisted_47 = {
  key: 0,
  class: "Contaider-options-bncc"
}
const _hoisted_48 = ["title"]
const _hoisted_49 = ["value"]
const _hoisted_50 = {
  key: 0,
  class: "error-message"
}
const _hoisted_51 = { class: "input-group" }
const _hoisted_52 = {
  key: 0,
  class: "error-message"
}
const _hoisted_53 = { class: "input-group" }
const _hoisted_54 = {
  key: 0,
  class: "input-group"
}
const _hoisted_55 = {
  key: 0,
  class: "error-message"
}

import MyNavBar from "@/components/MyNavBar.vue";
import MyFooter from "@/components/MyFooter.vue";
import api from "@/services/api";
import { ref, onBeforeMount, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { validateURL, fieldRequiredValidation } from "@/utils/validations";
import axios from "axios";

interface FormOption {
  id: number;
  name: string;
  code?: string;
  description?: string;
}

interface Snackbar {
  message: string;
  color: string;
  show: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateOA',
  setup(__props) {

const router = useRouter();

// Estado reativo
const etapa2 = ref(false);
const etapaAtual = ref(1);
const open = ref(false);
const openBncc = ref(false);
// Dados da etapa 1
const titulo = ref("");
const autorias = ref("");
const descricao = ref("");
const link = ref("");
const language = ref("");
const languageOptions = ref<FormOption[]>([]);
const seculos = ref([]);
const seculosOptions = ref<FormOption[]>([]);
const temporalidade = ref("");
const temporalidadeOptions = ref<FormOption[]>([]);
const nivelescolar = ref("");
const nivelescolarOptions = ref<FormOption[]>([]);
const espaco = ref("");
const espacoOptions = ref<FormOption[]>([]);
const tituloError = ref("");
const autoriasError = ref("");
const descricaoError = ref("");
const linkError = ref("");
const languageError = ref("");
const seculosError = ref("");
const temporalidadeError = ref("");
const nivelescolarError = ref("");
const espacoError = ref("");

// Dados da etapa 2
const conectividade = ref(2);
const conectividadeOptions = ref(1);
const observacao = ref("");
const classificacao = ref("");
const classificacaoError = ref("");
const bncc = ref<string[]>([]);
const bnccError = ref("");
const tags = ref([]);
const tagsError = ref("");
const imageError = ref("");
const classificacaoOptions = ref<FormOption[]>([]);
const bnccOptions = ref<FormOption[]>([]);
const tagsOptions = ref<FormOption[]>([]);

// Snackbar
const snackbar = ref<Snackbar>({
  message: "",
  color: "",
  show: false,
});

// Métodos da etapa 1
const validateSeculos = (): boolean => {
  if (seculos.value.length === 0) {
    seculosError.value = "Por favor, selecione pelo menos um século.";
    return false;
  }
  seculosError.value = "";
  return true;
};
const validateTitulo = () => {
  const validation = fieldRequiredValidation(titulo.value);
  tituloError.value = validation === true ? "" : validation;
};
const validateTags = () => {
  if (tags.value.length === 0) {
    tagsError.value = "Por favor, selecione pelo menos uma Tag.";
    return false;
  }
  tagsError.value = "";
  return true;
};
const validateLanguage = () => {
  languageError.value = language.value ? "" : "Selecione uma linguagem.";
};
const validateAutorias = () => {
  const validation = fieldRequiredValidation(autorias.value);
  autoriasError.value = validation === true ? "" : validation;
};
const validateTemporalidade = () => {
  temporalidadeError.value = temporalidade.value
    ? ""
    : "Selecione uma temporalidade.";
};
const validateEspaco = () => {
  espacoError.value = espaco.value ? "" : "Selecione um espaço.";
};
const validateNivelEscolar = () => {
  nivelescolarError.value = nivelescolar.value
    ? ""
    : "Selecione um nivel escolar.";
};
const validateDescricao = () => {
  const validation = fieldRequiredValidation(descricao.value);
  descricaoError.value = validation === true ? "" : validation;
};

const validateClassificacao = () => {
  const validation = fieldRequiredValidation(classificacao.value);
  classificacaoError.value = validation === true ? "" : validation;
};
const validateLink = () => {
  const validation = validateURL(link.value);
  linkError.value = validation === true ? "" : validation;
};
const validateBncc = () => {
  if (bncc.value.length === 0) {
    bnccError.value = "Por favor, selecione pelo menos um BNCC.";
    return false;
  }
  bnccError.value = "";
  return true;
};

// Métodos da etapa 2
const loadOptions = async () => {
  try {
    const response = await api.get("/language");
    languageOptions.value = response.data;
  } catch (error) {
    console.error("Erro na requisição:", error);
  }
  try {
    const response = await api.get("/location");
    espacoOptions.value = response.data;
  } catch (error) {
    console.error("Erro na requisição:", error);
  }
  try {
    const response = await api.get("/temporality");
    temporalidadeOptions.value = response.data;
  } catch (error) {
    console.error("Erro na requisição:", error);
  }
  try {
    const response = await api.get("/century/?limit=100");
    seculosOptions.value = response.data;
  } catch (error) {
    console.error("Erro na requisição:", error);
  }
  try {
    const response = await api.get("/school-level/?limit=20");
    nivelescolarOptions.value = response.data.filter(
      (item: { is_active: boolean }) => item.is_active
    );
  } catch (error) {
    console.error("Erro na requisição:", error);
  }
  try {
    const response = await api.get("/tag/?limit=1000000");
    tagsOptions.value = response.data.filter(
      (item: { is_active: boolean }) => item.is_active
    );
  } catch (error) {
    console.error("Erro na requisição:", error);
  }
  try {
    const response = await api.get("/bncc");
    bnccOptions.value = response.data;
  } catch (error) {
    console.error("Erro na requisição:", error);
  }
  try {
    const response = await api.get("/agerange/?limit=20");
    classificacaoOptions.value = response.data;
  } catch (error) {
    console.error("Erro na requisição:", error);
  }
};

const handleImageUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (file && file.size > 5 * 1024 * 1024) {
    imageError.value = "A imagem não pode exceder 5MB";
  } else {
    imageError.value = "";
  }
};

// Navegação
const handleNext = () => {
  validateTitulo();
  validateAutorias();
  validateDescricao();
  validateLink();
  validateLanguage();
  validateNivelEscolar();
  validateTemporalidade();
  validateEspaco();
  validateSeculos();

  if (
    !tituloError.value &&
    !autoriasError.value &&
    !descricaoError.value &&
    !linkError.value &&
    !languageError.value &&
    !seculosError.value &&
    !temporalidadeError.value &&
    !espacoError.value &&
    !nivelescolarError.value
  ) {
    etapa2.value = true;
    etapaAtual.value = 2;
    return true;
  } else {
    showSnackbar("Por favor, preencha todos os campos obrigatórios!", "error");
    return false;
  }
};

//Valores relativos
watch(
  [
    tags,
    language,
    titulo,
    autorias,
    link,
    descricao,
    seculos,
    temporalidade,
    espaco,
    nivelescolar,
    classificacao,
  ],
  () => {
    if (classificacao.value) {
      classificacaoError.value = "";
    }
    if (tags.value) {
      tagsError.value = "";
    }
    if (language.value) {
      languageError.value = "";
    }
    if (titulo.value) {
      tituloError.value = "";
    }
    if (autorias.value) {
      autoriasError.value = "";
    }
    if (link.value) {
      linkError.value = "";
    }
    if (descricao.value) {
      descricaoError.value = ""; // Limpa o erro de descricao
    }
    if (seculos.value) {
      seculosError.value = ""; // Limpa o erro de seculos
    }
    if (temporalidade.value) {
      temporalidadeError.value = ""; // Limpa o erro de temporalidade
    }
    if (espaco.value) {
      espacoError.value = ""; // Limpa o erro de espaco
    }
    if (nivelescolar.value) {
      nivelescolarError.value = ""; // Limpa o erro de nivelescolar
    }
  }
);

// Utilidades
const refreshTokens = async (refreshToken: string) => {
  const response = await api.post("/login/refresh/", {
    refresh: refreshToken,
  });
  localStorage.setItem("access_token", response.data.access);
  if (response.data.refresh) {
    localStorage.setItem("refresh_token", response.data.refresh);
  }
  return {
    accessToken: response.data.access,
    refreshToken: response.data.refresh || refreshToken,
  };
};
const criarTag = async (tags: string[]): Promise<number[]> => {
  const now = new Date().toISOString();
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) throw new Error("Refresh token não encontrado.");

  const { accessToken } = await refreshTokens(refreshToken);

  const tagIds = [];

  for (const tag of tags) {
    try {
      const response = await api.post(
        "/tag/",
        {
          name: tag,
          description: tag,
          created_at: now,
          updated_at: now,
          is_active: true,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const createdTag = response.data;

      tagIds.push(createdTag.id);
    } catch (error) {
      console.error(`Erro ao criar a tag '${tag}':`, error);
    }
  }

  return tagIds;
};

const clearField = () => {
  tags.value = [];
};

const removeSelection = (index: number) => {
  tags.value.splice(index, 1);
};

const textoStatusConectiviadade = computed(() => {
  switch (conectividadeOptions.value) {
    case 1:
      return "Offline";
    case 2:
      return "Parcial";
    case 3:
      return "Online";
  }
  return null;
});
function trocarConectividade() {
  // gira entre 1, 2, 3
  conectividadeOptions.value = (conectividadeOptions.value % 3) + 1;

  // mapeia pro valor que o back espera
  switch (conectividadeOptions.value) {
    case 1:
      conectividade.value = 2; // Offline
      break;
    case 2:
      conectividade.value = 3; // Parcial
      break;
    case 3:
      conectividade.value = 1; // Online
      break;
  }
}
const voltarPages = () => {
  etapa2.value = false;
  etapaAtual.value = 1;
};
const toggleDropdownAndValidate = () => {
  const wasOpen = open.value;
  open.value = !wasOpen; // Alterna estado

  if (wasOpen) {
    // Se estava aberto e agora fechou
    validateSeculos();
  }
};
const toggleDropdownBnccAndValidate = () => {
  const wasOpen = openBncc.value;
  openBncc.value = !wasOpen; // Alterna estado

  if (wasOpen) {
    // Se estava aberto e agora fechou
    validateBncc();
  }
};
const handleSubmit = async () => {
  if (!handleNext()) {
    showSnackbar(
      "Não foi possível enviar: os dados da etapa anterior não foram salvos!",
      "error"
    );
    return;
  }

  if (validateForm()) {
    if (
      tags.value.some((tag) => typeof tag === "string" && isNaN(Number(tag)))
    ) {
      const newTags = tags.value.filter((tag) => typeof tag === "string");
      const createdTagIds = await criarTag(newTags);
      (tags.value as any) = tags.value.map((tag) =>
        typeof tag === "string" && isNaN(Number(tag))
          ? createdTagIds.shift() ?? tag
          : tag
      );
    }
    const toArray = (val: any) =>
      Array.isArray(val) ? val : val !== undefined && val !== null ? [val] : [];
    const formData = {
      cataloguer:
        JSON.parse(localStorage.getItem("baobahUser") || "{}").id || null,
      title: titulo.value,
      author: autorias.value,
      description: descricao.value,
      link: link.value,
      observation: observacao.value,
      languages: toArray(language.value),
      centuries: toArray(seculos.value),
      temporalities: toArray(temporalidade.value),
      locations: toArray(espaco.value),
      school_levels: toArray(nivelescolar.value),
      connectivities: toArray(conectividade.value),
      age_ranges: toArray(classificacao.value),
      bnccs: toArray(bncc.value),
      tags: toArray(tags.value),
    };
    try {
      const refreshToken = localStorage.getItem("refresh_token");
      if (!refreshToken) throw new Error("Refresh token não encontrado.");

      const { accessToken } = await refreshTokens(refreshToken);

      const response = await api.post("/lobjects/", formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      // console.log("JSON completo:", JSON.stringify(formData, null, 2));
      // console.log("Resposta do servidor:", response.data);
      showSnackbar("Formulário enviado com sucesso!", "success");
      router.push("/");
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Erro da API:", error.response?.data || error.message);
      } else {
        console.error("Erro desconhecido:", error);
      }
      showSnackbar("Erro ao enviar o formulário!", "error");
    }
  }
};

const validateForm = (): boolean => {
  validateTags();
  validateBncc();
  validateClassificacao();

  if (
    !tagsError.value &&
    !bnccError.value &&
    !classificacaoError.value &&
    !tituloError.value &&
    !autoriasError.value &&
    !descricaoError.value &&
    !linkError.value &&
    !languageError.value &&
    !seculosError.value &&
    !temporalidadeError.value &&
    !espacoError.value &&
    !nivelescolarError.value
  ) {
    showSnackbar("Formulário enviado com sucesso!", "success");
    return true;
  } else {
    showSnackbar("Por favor, preencha todos os campos obrigatórios!", "error");
    return false;
  }
};

const showSnackbar = (message: string, color: string) => {
  snackbar.value = {
    message,
    color,
    show: true,
  };

  setTimeout(() => {
    snackbar.value.show = false;
  }, 3000);
};

const handleCancel = () => {
  router.push("/");
};

// Lifecycle hooks
onBeforeMount(() => {
  loadOptions();
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MyNavBar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[40] || (_cache[40] = _createElementVNode("h1", { class: "form-title" }, "Submissão de Objeto de Aprendizagem", -1)),
        _cache[41] || (_cache[41] = _createElementVNode("p", { class: "form-subtitle" }, "Preencha o formulário abaixo.", -1)),
        _createElementVNode("p", _hoisted_3, "Etapa " + _toDisplayString(etapaAtual.value) + " de 2", 1),
        (!etapa2.value)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              onSubmit: _withModifiers(handleNext, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { for: "titulo" }, "Título", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "titulo",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((titulo).value = $event)),
                    class: _normalizeClass({ 'invalid-input': tituloError.value }),
                    onBlur: validateTitulo,
                    placeholder: "Digite o título"
                  }, null, 34), [
                    [_vModelText, titulo.value]
                  ]),
                  (tituloError.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(tituloError.value), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { for: "autorias" }, "Autoria", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "autorias",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((autorias).value = $event)),
                    class: _normalizeClass({ 'invalid-input': autoriasError.value }),
                    onBlur: validateAutorias,
                    placeholder: "Digite a autoria"
                  }, null, 34), [
                    [_vModelText, autorias.value]
                  ]),
                  (autoriasError.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(autoriasError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "descricao" }, "Descrição", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "descricao",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((descricao).value = $event)),
                  class: _normalizeClass({ 'invalid-input': descricaoError.value }),
                  onBlur: validateDescricao,
                  placeholder: "Digite a descrição"
                }, null, 34), [
                  [_vModelText, descricao.value]
                ]),
                (descricaoError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(descricaoError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { for: "link" }, "Link", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "link",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((link).value = $event)),
                  class: _normalizeClass({ 'invalid-input': linkError.value }),
                  onBlur: validateLink,
                  placeholder: "Digite o link"
                }, null, 34), [
                  [_vModelText, link.value]
                ]),
                (linkError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(linkError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { for: "language" }, "Linguagens", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "language",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((language).value = $event)),
                  onBlur: validateLanguage,
                  class: _normalizeClass({ 'invalid-input': languageError.value })
                }, [
                  _cache[17] || (_cache[17] = _createElementVNode("option", {
                    disabled: "",
                    value: ""
                  }, "Selecione a linguagem", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageOptions.value, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.id,
                      value: option.id
                    }, _toDisplayString(option.name), 9, _hoisted_14))
                  }), 128))
                ], 34), [
                  [_vModelSelect, language.value]
                ]),
                (languageError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(languageError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { for: "seculos" }, "Séculos", -1)),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h3", {
                    onClick: toggleDropdownAndValidate,
                    class: _normalizeClass({ 'invalid-input': seculosError.value })
                  }, [
                    (seculos.value.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(seculos.value
                    .sort((a, b) => a - b)
                    .map((s) => {
                      const option = seculosOptions.value.find((opt) => opt.id === s);
                      return `Século ${option ? option.name : s}`;
                    })
                    .join(", ")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, "Selecione os Séculos")),
                    (open.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _cache[19] || (_cache[19] = [
                          _createElementVNode("img", {
                            style: {"transform":"rotate(180deg)","transition":"transform 0.3s ease-in-out"},
                            src: _imports_0
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _cache[20] || (_cache[20] = [
                          _createElementVNode("img", { src: _imports_0 }, null, -1)
                        ])))
                  ], 2),
                  (open.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seculosOptions.value, (option) => {
                          return (_openBlock(), _createElementBlock("label", {
                            class: "values-seculos",
                            key: option.id
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: option.id,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((seculos).value = $event)),
                              onChange: validateSeculos
                            }, null, 40, _hoisted_23), [
                              [_vModelCheckbox, seculos.value]
                            ]),
                            _createElementVNode("p", null, _toDisplayString(option.name), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (seculosError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(seculosError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { for: "temporalidade" }, "Temporalidade", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "temporalidade",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((temporalidade).value = $event)),
                  class: _normalizeClass({ 'invalid-input': temporalidadeError.value }),
                  onBlur: validateTemporalidade
                }, [
                  _cache[22] || (_cache[22] = _createElementVNode("option", {
                    disabled: "",
                    value: ""
                  }, "Selecione a temporalidade", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(temporalidadeOptions.value, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.id,
                      value: option.id
                    }, _toDisplayString(option.name), 9, _hoisted_26))
                  }), 128))
                ], 34), [
                  [_vModelSelect, temporalidade.value]
                ]),
                (temporalidadeError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(temporalidadeError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { for: "espaco" }, "Espaço", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "espaco",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((espaco).value = $event)),
                  class: _normalizeClass({ 'invalid-input': espacoError.value }),
                  onBlur: validateEspaco
                }, [
                  _cache[24] || (_cache[24] = _createElementVNode("option", {
                    disabled: "",
                    value: ""
                  }, "Selecione o espaço", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(espacoOptions.value, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.id,
                      value: option.id
                    }, _toDisplayString(option.name), 9, _hoisted_29))
                  }), 128))
                ], 34), [
                  [_vModelSelect, espaco.value]
                ]),
                (espacoError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(espacoError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { for: "nivelescolar" }, "Nivel Escolar", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "nivelescolar",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((nivelescolar).value = $event)),
                  class: _normalizeClass({ 'invalid-input': nivelescolarError.value }),
                  onBlur: validateNivelEscolar
                }, [
                  _cache[26] || (_cache[26] = _createElementVNode("option", {
                    disabled: "",
                    value: ""
                  }, "Selecione o nível escolar", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nivelescolarOptions.value, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.id,
                      value: option.id
                    }, _toDisplayString(option.name), 9, _hoisted_32))
                  }), 128))
                ], 34), [
                  [_vModelSelect, nivelescolar.value]
                ]),
                (nivelescolarError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(nivelescolarError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", { class: "button-group" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "cancel-button",
                  onClick: handleCancel
                }, " Cancelar "),
                _cache[28] || (_cache[28] = _createElementVNode("button", {
                  type: "submit",
                  class: "next-button"
                }, "Próximo", -1))
              ])
            ], 32))
          : (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _withModifiers(handleSubmit, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { for: "conctividade" }, "Conectividade", -1)),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["switch-container", 'estado-' + conectividadeOptions.value]),
                      onClick: trocarConectividade,
                      tabindex: "0",
                      onKeydown: _withKeys(trocarConectividade, ["enter"]),
                      role: "switch"
                    }, _cache[29] || (_cache[29] = [
                      _createElementVNode("div", { class: "switch-indicator" }, null, -1),
                      _createElementVNode("div", {
                        id: "conctividade",
                        class: "switch-labels"
                      }, [
                        _createElementVNode("span"),
                        _createElementVNode("span"),
                        _createElementVNode("span")
                      ], -1)
                    ]), 34),
                    _createElementVNode("p", _hoisted_37, _toDisplayString(textoStatusConectiviadade.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { for: "classificacao" }, "Classificação Indicativa", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "classificacao",
                    onBlur: validateClassificacao,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((classificacao).value = $event))
                  }, [
                    _cache[31] || (_cache[31] = _createElementVNode("option", {
                      disabled: "",
                      value: ""
                    }, "Selecione a classificação", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classificacaoOptions.value, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.id,
                        value: option.id
                      }, _toDisplayString(option.name), 9, _hoisted_39))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, classificacao.value]
                  ]),
                  (classificacaoError.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(classificacaoError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { for: "bncc" }, "BNCC", -1)),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("h3", {
                    tabindex: "0",
                    onKeydown: _withKeys(toggleDropdownBnccAndValidate, ["enter"]),
                    onClick: toggleDropdownBnccAndValidate,
                    class: _normalizeClass({ 'invalid-input': bnccError.value })
                  }, [
                    (bncc.value.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(bncc.value
                    .map((b) => {
                      const option = bnccOptions.value.find(
                        (opt) => opt.id === Number(b)
                      );
                      return option ? option.code : b;
                    })
                    .join(", ")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_44, "Selecione os Itens da BNCC")),
                    (openBncc.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, _cache[33] || (_cache[33] = [
                          _createElementVNode("img", {
                            style: {"transform":"rotate(180deg)","transition":"transform 0.3s ease-in-out"},
                            src: _imports_0
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("span", _hoisted_46, _cache[34] || (_cache[34] = [
                          _createElementVNode("img", { src: _imports_0 }, null, -1)
                        ])))
                  ], 34),
                  (openBncc.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bnccOptions.value, (option) => {
                          return (_openBlock(), _createElementBlock("label", {
                            class: "values-bncc",
                            key: option.id
                          }, [
                            _createElementVNode("label", {
                              title: option.description,
                              tabindex: "0",
                              class: "item-bncc"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                tabindex: "-1",
                                style: {"width":"auto"},
                                type: "checkbox",
                                value: option.id,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((bncc).value = $event)),
                                onChange: validateBncc
                              }, null, 40, _hoisted_49), [
                                [_vModelCheckbox, bncc.value]
                              ]),
                              _createTextVNode(" " + _toDisplayString(option.code), 1)
                            ], 8, _hoisted_48)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (bnccError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(bnccError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_51, [
                _cache[36] || (_cache[36] = _createElementVNode("label", {
                  style: {"margin-bottom":"8px"},
                  for: "tags"
                }, "Tags", -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_combobox, {
                    density: "compact",
                    class: "custom-combobox",
                    modelValue: tags.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((tags).value = $event)),
                    "menu-icon": "mdi-chevron-down",
                    label: "Selecione as tags",
                    items: tagsOptions.value,
                    "item-title": "name",
                    "item-value": "id",
                    multiple: "",
                    variant: "outlined",
                    "hide-selected": "",
                    "hide-details": "",
                    "return-object": false,
                    onBlur: validateTags,
                    "onClick:clear": clearField,
                    "menu-props": {
                maxHeight: 200,
                offset: 5,
                contentClass: 'small-menu',
                attach: 'body',
                location: 'bottom',
                eager: true,
                closeOnContentClick: true,
              }
                  }, {
                    selection: _withCtx(({ item, index }) => [
                      (item === Object(item))
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            color: "var(--terracota)",
                            size: "small",
                            variant: "flat",
                            closable: "",
                            label: "",
                            "onClick:close": ($event: any) => (removeSelection(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick:close"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "items"]),
                  (tagsError.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(tagsError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _cache[37] || (_cache[37] = _createElementVNode("label", { for: "observacao" }, "Observação", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "observacao",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((observacao).value = $event)),
                  placeholder: "Digite a observação (opcional)"
                }, null, 512), [
                  [_vModelText, observacao.value]
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", null, "Imagem", -1)),
                    _createElementVNode("input", {
                      type: "file",
                      onChange: handleImageUpload,
                      accept: "image/jpeg, image/png, image/gif"
                    }, null, 32),
                    (imageError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(imageError.value), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", { class: "button-group" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "cancel-button",
                  onClick: voltarPages
                }, " Voltar "),
                _cache[39] || (_cache[39] = _createElementVNode("button", {
                  type: "submit",
                  class: "next-button"
                }, "Cadastrar", -1))
              ])
            ], 32)),
        (snackbar.value.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(['snackbar', snackbar.value.color])
            }, _toDisplayString(snackbar.value.message), 3))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(MyFooter)
  ], 64))
}
}

})